import customerAddressApi from '@/api/Methods/Customer/Customer-Address-API-Methods';
import customerContactApi from '@/api/Methods/Customer/Customer-Contact-API-Methods';
import customerGroupApi from '@/api/Methods/Customer/Customer-Group-API-Methods';
import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async searchCustomersByString(query, limit = 1000, cancelationToken) {
            var meta = { clientApiMethod: 'searchCustomersByString', input: { query: query } }
            var querystring = encodeURI(query)
            var response = await client().get(store.state.apiRouteRoot + "customer/search?searchQuery=" + querystring + "&limit=" + limit, { signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getCustomerListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getCustomerListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "customer/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getCustomerById(customerId) {
            var meta = { clientApiMethod: 'getCustomerById', input: { customerId: customerId } }
            var response = await client().get(store.state.apiRouteRoot + "customer/?id=" + encodeURI(customerId), { meta: meta })
            return response?.data;
        },
        async createCustomer(newcustomer) {
            var meta = {
                clientApiMethod: 'createCustomer',
                input: { newcustomer },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.customer.customer") })
            }
            var response = await client().post(store.state.apiRouteRoot + "customer/", newcustomer, { meta: meta })
            return response?.data;
        },
        async changeCustomerById(updatedCustomer) {
            var meta = {
                clientApiMethod: 'changeCustomerById',
                input: { updatedCustomer },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.customer.customer") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "customer/" + updatedCustomer.Id, updatedCustomer, { meta: meta })
            return response?.data;
        },
        async getCustomerActiveById(id) {
            var meta = {
                clientApiMethod: 'getCustomerActiveById',
                input: { id }
            }
            var response = await client().get(store.state.apiRouteRoot + "customer/" + id + "/GetActiveState", { meta: meta })
            return response?.data;
        },
        async toggleCustomerActiveById(id) {
            var meta = {
                clientApiMethod: 'toggleCustomerActiveById',
                input: { id },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.customer.customer") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "customer/" + id + "/ToggleActiveState", null, { meta: meta })
            return response?.data;
        },
        async getCustomerPublicById(id) {
            var meta = {
                clientApiMethod: 'getCustomerPublicById',
                input: { id }
            }
            var response = await client().get(store.state.apiRouteRoot + "customer/" + id + "/GetPublicState", { meta: meta })
            return response?.data;
        },
        async toggleCustomerPublicById(id) {
            var meta = {
                clientApiMethod: 'toggleCustomerPublicById',
                input: { id },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.customer.customer") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "customer/" + id + "/TogglePublicState", null, { meta: meta })
            return response?.data;
        },
        async swapCustomer(jobId, customerId) {
            var meta = {
                clientApiMethod: 'swapCustomer',
                input: { jobId: jobId, customerId: customerId },
                successText: 'Successfully swapped customer'
            }
            var response = await client().patch(store.state.apiRouteRoot + "job/" + jobId + "/swapcustomer/" + customerId, null, { meta: meta })
            return response?.data;
        },
        ...customerAddressApi.methods,
        ...customerContactApi.methods,
        ...customerGroupApi.methods,
    }
}